<template>
  <v-card>
    <v-card-title>Avançar em massa</v-card-title>
    <v-card-text>
      Você tem certeza que deseja avançar esses agendamentos?
      <br />
      Essa ação não pode ser desfeita.
      <v-card-actions class="justify-end">
        <v-btn color="error" :disabled="quantidade < 1" @click="callback"
          >Avançar ({{ quantidade }})</v-btn
        >
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ModalAvancarCaminhoes',
  props: {
    callback: {
      type: Function,
      required: true,
    },
    quantidade: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {}
  },
  computed: {},
  methods: {},
}
</script>
